"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILDefaultAvatar = void 0;
var react_1 = __importDefault(require("react"));
function ILDefaultAvatar(_a) {
    var _b = _a.color, color = _b === void 0 ? 'black' : _b, props = __rest(_a, ["color"]);
    return (react_1.default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "115", height: "115", fill: "none", viewBox: "0 0 115 115" }, props),
        react_1.default.createElement("g", { fill: color, clipPath: "url(#clip0)" },
            react_1.default.createElement("path", { d: "M57.5 76.67c-22.92 0-41.5 17.221-41.5 38.464h83c0-21.243-18.58-38.463-41.5-38.463z" }),
            react_1.default.createElement("ellipse", { cx: "57.5", cy: "44.787", rx: "24.293", ry: "23.787" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: "clip0" },
                react_1.default.createElement("path", { fill: "#fff", d: "M0 0H115V115H0z" })))));
}
exports.ILDefaultAvatar = ILDefaultAvatar;
